module.exports = __webpack_public_path__ + "static/img/stage-2.3b4e61db.png";